import React, { useEffect, useState, useRef } from 'react';
import { Button, Badge, Modal } from "react-bootstrap";
import rice from '../../../../images/raw_material/rice.png';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css'; 
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';    
import $ from 'jquery';
import { Link } from 'react-router-dom'; 
import { toast } from 'react-toastify';
import swal from 'sweetalert2'; 
const StockPurchase = ({ show, onClose, purchaseId, refresh }) => {
    
    const tableRef = useRef(null);
    

    const [purchase, setPurchase] = useState(null); 
    const [loading, setLoading] = useState(false); // <-- ADD THIS
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    useEffect(() => {
        if (purchaseId && show) {
            fetch(`${baseURL}/purchases/${purchaseId}`)
                .then(res => res.json())
                .then(data => setPurchase(data.data))
                .catch(err => console.error(err));
        }
    }, [purchaseId, show]);

    useEffect(() => {
        if (tableRef.current && !$.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable({
                responsive: true,
                pageLength: 25,
                ordering: false,
                language: { lengthMenu: "Show&nbsp;&nbsp; _MENU_" },
            });
        }
    }, [purchase]);

    if (!purchase) return null; // show nothing while loading


    // const handleMoveToStock = async () => {
    //     setLoading(true);
    //     try {
    //         const payload = {
    //             raw_material: purchase.raw_material.map(rm => ({
    //                 raw_material_id: rm.raw_material_id,
    //                 actual_quantity: rm.actual_quantity,
    //                 actual_price: rm.actual_price,
    //                 brand: rm.brand_name,
    //                 expiry_date: rm.expiry_date || null // optional, if exists
    //             })),
    //             discount: purchase.discount || 0,
    //             gst: purchase.gst || 0,
    //             verification_reason: purchase.verification_reason || '',
    //             movestock: 0 // trigger stock creation
    //         };

    //         const res = await fetch(`${baseURL}/manage-purchase/verify/${purchase.sno}`, {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Accept': 'application/json',
    //             },
    //             body: JSON.stringify(payload)
    //         });

    //         const data = await res.json();

    //         if (res.ok) {
    //             toast.success("Purchase moved to stock successfully!");
    //             refresh();
    //             onClose();
                
    //         } else {
    //             toast.error('Something went wrong');
    //             refresh();
    //         }
    //     } catch (err) {
    //         console.error(err);
    //         toast.error('Error moving purchase to stock');
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handleMoveToStock = () => {
    if (!purchase) return;

    swal.fire({
        html: `
            <div class="text-center mb-2">
                <i class="fas fa-exclamation-circle fa-3x text-warning"></i>
            </div>
            <div class="alert alert-info px-2 py-2" role="alert">
                Choose Destination
            </div>
            <div class="row mb-2 text-center">
                <label class="text-black font-w300">
                    <b>Do you want to move this purchase to <strong class="text-success">Stock</strong> or <strong class="text-primary">Kitchen</strong>?</b>
                </label>
            </div>
        `,
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'Stock',
        denyButtonText: 'Kitchen',
        cancelButtonText: 'Cancel',
        reverseButtons: true,
        customClass: {
            title: 'fs-6',
            cancelButton: 'btn btn-sm btn-secondary',
            confirmButton: 'btn btn-sm btn-success',
            denyButton: 'btn btn-sm btn-primary',
            htmlContainer: 'text-left'
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
    }).then(async (result) => {
        if (result.isConfirmed) {
            // Stock selected
            await movePurchaseTo(5); 
        } else if (result.isDenied) {
            // Kitchen selected
            await movePurchaseTo(8); 
        }
    });
};

// Function to call API with desired purchase_status
const movePurchaseTo = async (status) => {
    setLoading(true);
    try {
        const payload = {
            raw_material: purchase.raw_material.map(rm => ({
                raw_material_id: rm.raw_material_id,
                actual_quantity: rm.actual_quantity,
                actual_price: rm.actual_price,
                brand: rm.brand_name,
                expiry_date: rm.expiry_date || null
            })),
            discount: purchase.discount || 0,
            gst: purchase.gst || 0,
            verification_reason: purchase.verification_reason || '',
            movestock: 0,
            purchase_status: status
        };

        const res = await fetch(`${baseURL}/manage-purchase/verify/${purchase.sno}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(payload)
        });

        if (res.ok) {
            toast.success(`Purchase moved to ${status === 5 ? 'Stock' : 'Kitchen'} successfully!`);
            refresh();
            onClose();
        } else {
            toast.error('Something went wrong');
            refresh();
        }
    } catch (err) {
        console.error(err);
        toast.error('Error moving purchase');
    } finally {
        setLoading(false);
    }
};
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };


    return (
        <Modal show={show} size="xl" >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Stock Purchase
                    </h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Purchase ID</label>
                            <label className='text-danger fs-6 font-w500'>{purchase.purchase_id}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Purchase Date</label>
                            <label className='text-danger fs-6 font-w500'>{formatDate(purchase.purchase_date)}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Vendor</label>
                            <label className='text-danger fs-6 font-w500'>{purchase.vendor_businessname}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Estimated / Actual Amount</label>
                            <label className='text-danger fs-6 font-w500'>₹ {purchase.estimate_amount} / ₹ {purchase.actual_amount}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Purchas Status</label>
                            <label className='text-danger fs-6 font-w500'>
                                {purchase.purchase_status === 0 && 'Generated'}
                                {purchase.purchase_status === 1 && 'Verification Pending'}
                                {purchase.purchase_status === 2 && 'Material Received'}
                                {purchase.purchase_status === 3 && 'Partial Verified'}
                                {purchase.purchase_status === 4 && 'Verified'}
                                {purchase.purchase_status === 5 && 'Material Stocked'}
                                {purchase.purchase_status === 7 && 'Payment Completed'}  
                                {purchase.purchase_status === 8 && 'Material Stocked'}      
                            </label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Assign Staff</label>
                            <label className='text-danger fs-6 font-w500'>{purchase.purchase_staffname}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Items Purchased</label>
                            <label>
                                <span className='text-white fs-6 font-w500 py-1 px-2 rounded' style={{backgroundColor: '#33A9FF'}}>{purchase.no_of_rawmaterial.toString().padStart(2, '0')}</span>
                            </label>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="table-container">
                            <table ref={tableRef} className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                <thead>
                                    <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                        <th className='min-w-100px'>Raw Material / Base Cost</th>
                                        <th className='min-w-100px'>Brand</th>
                                        <th className='min-w-50px text-center'>Estimated / Actual Qty</th>
                                        <th className='min-w-50px'>Estimated / Actual Amount</th>
                                    </tr>
                                </thead>
                             
                                <tbody className="text-gray-600 fw-semibold fs-7">
                                {purchase.raw_material.map((rm) => (
                                    <tr key={rm.id}>
                                        <td>
                                            <label className='fs-7 text-black'>{rm.rawmaterial_name}</label>
                                            <div className='d-block'>
                                                <label className='text-info fs-7 fw-bold me-2'>₹ {rm.per_unit_cost} /-</label>
                                                (<label className='fs-7 text-black'>1 {rm.unitslug_name}</label>)
                                            </div>
                                        </td>
                                        <td><label className='fs-7 text-black'>{rm.brand_name ?? '-'}</label></td>
                                        <td>
                                            <div className='text-center d-flex align-items-center justify-content-center gap-1'>
                                                <label className='fs-7 text-black'>{rm.quantity}</label>
                                                <label>|</label>
                                                <label className='fs-7 text-black'>{rm.actual_quantity}</label>
                                                <span className='fs-7 text-black'>{rm.unitslug_name}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='d-flex gap-1 justify-content-end'>
                                                <Badge bg="success" className='fs-7 py-0 px-1'>
                                                    ₹ {rm.total_cost}
                                                </Badge>
                                                <label>|</label>
                                                <Badge bg="danger" className='fs-7 py-0 px-1'>
                                                    ₹ {rm.actual_price}
                                                </Badge>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            </table>
                        </div>
                    </div>
                    
                     <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                        <Button 
                            className="btn btn-primary" 
                            onClick={handleMoveToStock} 
                            disabled={loading}
                        >
                            {loading ? 'Processing...' : 'Move To Stock'}
                            <i className="fas fa-angle-double-right ms-2"></i>
                        </Button>
                    </div>
                </div>
            </div>
        </Modal >
    );
};

export default StockPurchase;